export default __webpack_public_path__ + "img/allergy-nuts.fee771659efdbc046ea580e1a2af4f78.svg";